var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.03 11.4714L13.03 8.47141C12.74 8.18141 12.26 8.18141 11.97 8.47141C11.68 8.76141 11.68 9.24141 11.97 9.53141L13.69 11.2514H8.5C8.09 11.2514 7.75 11.5914 7.75 12.0014C7.75 12.4114 8.09 12.7514 8.5 12.7514H13.69L11.97 14.4714C11.68 14.7614 11.68 15.2414 11.97 15.5314C12.12 15.6814 12.31 15.7514 12.5 15.7514C12.69 15.7514 12.88 15.6814 13.03 15.5314L16.03 12.5314C16.32 12.2414 16.32 11.7614 16.03 11.4714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6abbc6f3cd74614ccbcb86ce2235bd2c.svg";
export { ForwardRef as ReactComponent };